import React from "react";
import { getBranches, deleteBranch } from "../../../api/branches";
import {
  formatDocument,
  formatDate,
  setCookieByName
} from "../../../utils";
import Page from "../../../_components/Layout/Page";
import Row from "../../../_components/Layout/Row";
import Column from "../../../_components/Layout/Column";
import Card from "../../../_components/Card";
import Text from "../../../_components/Text";
import Button from "../../../_components/Button";
import LoadingInput from "../../../_components/LoadingInput";
import { useUpdateCookies } from "./hooks";
import SweetAlert from "react-bootstrap-sweetalert";

export default () => {
  const ref = React.useRef();

  // Estados do componente
  const [loading, setLoading] = React.useState(true);
  const [searchValue, setSearchValue] = React.useState('');
  const [allBranches, setAllBranches] = React.useState([]);
  const [filteredBranches, setFilteredBranches] = React.useState([]);
  const [showCancelModal, setShowCancelModal] = React.useState(false);
  const [selectedBranch, setSelectedBranch] = React.useState(null);

  const updateCookies = useUpdateCookies();

  /**
   * Carrega os dados das filiais na montagem do componente
   */
  React.useEffect(() => {
    getBranches()
      .then((response) => {
        const activeBranches = response.filter(branch => branch.status !== 2)
        setAllBranches(activeBranches);
        setFilteredBranches(activeBranches);
        setCookieByName("branch_count", activeBranches.length);
      })
      .finally(() => setLoading(false));
  }, []);

  /**
   * Lógica de filtragem de uma filial com base no valor de busca
   */
  const filterBranch = React.useCallback((branch, value) => {
    const lowerValue = value.toLowerCase();

    if (branch.company) {
      return (
        branch.company.cnpj.includes(value) ||
        branch.company.fancy_name.toLowerCase().includes(lowerValue)
      );
    }

    return (
      branch.individual.cpf.includes(value) ||
      branch.name.toLowerCase().includes(lowerValue)
    );
  }, []);

  /**
   * Manipula a entrada do campo de busca e atualiza a lista filtrada
   */
  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchValue(value);

    if (!value) {
      setFilteredBranches(allBranches);
      return;
    }

    const filtered = allBranches.filter(branch =>
      filterBranch(branch, value)
    );
    setFilteredBranches(filtered);
  };

  /**
   * Função para desativar uma filial
   */
  const handleDeleteBranch = () => {
    if (selectedBranch) {
      deleteBranch(selectedBranch.id)
        .then(() => {
          setAllBranches(prev => prev.filter(b => b.id !== selectedBranch.id));
          setFilteredBranches(prev => prev.filter(b => b.id !== selectedBranch.id));
          setShowCancelModal(false);
          setSelectedBranch(null);

      getBranches()
        .then((response) => {
          const activeBranches = response.filter(branch => branch.status !== 2)
          setCookieByName("branch_count", activeBranches.length)})
          
        })
        .catch((error) => {
          console.error("Erro ao deletar filial:", error);
        });
    }
  };

  const handleOpenDeleteModal = (branch) => {
    setSelectedBranch(branch);
    setShowCancelModal(true);
  };

  /**
   * Renderiza o conteúdo principal da página
   */
  return (
    <Page loading={loading} title="Empresas cadastradas" ref={ref}>
      {allBranches.length > 10 && (
        <Column xs="12" md="4" lg="4">
          <LoadingInput
            placeholder="Buscar filial (cnpj/cpf, razão social)"
            value={searchValue}
            onChange={handleSearch}
          />
        </Column>
      )}

      <SweetAlert
        show={showCancelModal}
        type={'info'}
        showCancel={true}
        confirmBtnText="Desativar"
        cancelBtnText="Cancelar"
        title="Deseja desativar esta filial?"
        onConfirm={handleDeleteBranch}
        onCancel={() => setShowCancelModal(false)}
      >
        Esse processo é irreversível
      </SweetAlert>

      <Row>
        {filteredBranches.map((branch) => {
          const name = branch.individual
            ? branch.name
            : branch.company.fancy_name;

          const cpfCnpj = branch.individual
            ? branch.individual.cpf
            : branch.company.cnpj;

          const branchPlan = branch.branch_plan
            ? <Text>Assinatura: {branch.branch_plan.plan_name}</Text>
            : <Text color="danger">Sem assinatura</Text>;

          const nextInvoice = branch.branch_plan && (
            <Text>Próxima cobrança: {formatDate(branch.branch_plan.end_date)}</Text>
          );

          const digitalCertificate = branch.certificate
            ? <Text>Certificado digital vence em: {formatDate(branch.certificate.expiry_date)}</Text>
            : <Text color="danger">Certificado digital não cadastrado</Text>;

          const remainingNotes = branch.branch_plan && (
            <Text>
              Notas disponíveis:{" "}
              {Math.max(
                0,
                branch.branch_plan.notes_quantity -
                branch.branch_plan.total_sended_notes
              )}
            </Text>
          );

          return (
            <Column xs="12" md="4" lg="3" key={`branch-list-${branch.id}`}>
              <Card
                title={name}
                footer={
                  <div className="d-flex justify-content-center">
                    <Button onClick={() => updateCookies(branch)} as="text">
                      Selecionar empresa
                    </Button>
                  </div>
                }
                view={() => {
                  updateCookies(branch)
                  window.location.href = "/plans"
                }}
                certificate={() => {
                  updateCookies(branch)
                  window.location.href = "/digital-certificate"
                }}
                edit={() => {
                  updateCookies(branch)
                  window.location.href = "/settings/branch"
                }}
                delete={() => handleOpenDeleteModal(branch)}


              >
                <Text>{formatDocument(cpfCnpj)}</Text>
                {branchPlan}
                {nextInvoice}
                {remainingNotes}
                {digitalCertificate}
              </Card>

            </Column>
          );
        })}
      </Row>
    </Page>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Branches/index.jsx